<ng-container *ngIf="finance">
  <ion-item>
    <ion-label>Asistent obdrží</ion-label>
    <ul>
      <li *ngFor="let a of finance.assistants">{{ a.fullname }}: {{ a.sum }} Kč</li>
    </ul>
  </ion-item>

  <ion-item>
    <ion-label>Klient zaplatí</ion-label>
    {{ finance.clientSum }} Kč
  </ion-item>
</ng-container>
